import { LoginFormState } from '../../../context/login/LoginFormState';
import { Form } from '../loginForm/form';
import useDocumentTitle from '../../../components/Title';

export const LoginFormPage = () => {
  useDocumentTitle("Panel - El Gran Bazar Chino");
  return (
    <LoginFormState>
        <Form title="Iniciar Sesion" />
    </LoginFormState>
  );
};
